<template>
    <div>
        <section class="page-title">        
            <!-- <v-img 
                v-if="this.$vuetify.breakpoint.lg"
                height="320px"
                :src="require('@/Content/images/banner1.jpg')"
                class="white--text"
                gradient="to right, rgba(255, 255, 255, 0.5), rgba(249, 250, 224, 0.3)"
                max-width="100%"
                position="center top"
            >
                <div class="center">
                    <p class="label-planos" >Pessoa Física</p>
                    <h1 class="the-title"><span>Soluções</span> para você</h1>
                    <p style="color:#666">Temos o plano certo para cuidar da saúde bucal de toda a família!</p>
                    <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar Agora</a>
                </div>
            </v-img> -->
            <!-- <v-img 
                v-else
                height="300"        
                class="white--text"
                gradient="to right, rgba(255, 255, 255, 0.5), rgba(249, 250, 224, 0.3)"
                max-width="100%"  
                position="center top"        
            >
                <div class="center">
                    <p class="label-planos" >Pessoa Física</p>
                    <h1 class="the-title"><span>Soluções</span> para você</h1>
                    <p style="color:#7593b4">Dê o primeiro passo e garanta um sorriso saudável</p>
                    <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar Agora</a>
                </div>
            </v-img> -->
        </section>
        <section class="page-content center">
            <div class="contrataragora"> 
                <v-fade-transition mode="out-in">    
                    <div class="exibelocalizacao" v-if="exibeLocalizacao">
                        <div class="planos-wrapper">
                            <p class="planos-title">Local de utilização</p>
                            <v-layout align-center>
                                <v-flex xs12 sm12>
                                    <v-card
                                        flat
                                        max-height="400px"
                                        max-width="600px"
                                        class="mx-auto localizacao"
                                        style="border: 1px solid; border-color: #0098DA;border-radius: 10px;"
                                    >
                                        <v-card-text>
                                            <v-container grid-list-md>
                                                <v-layout align-center justify-center row wrap>
                                                    <v-flex xs12 sm12 lg3>
                                                        <v-autocomplete
                                                            id="comboOrgao"
                                                            v-model="UfId"
                                                            item-value="Id"
                                                            item-text="Sigla"
                                                            :items="UFs"
                                                            label="Estado"  
                                                            @input="carregaCidades()"
                                                        ></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 lg7>
                                                        <v-autocomplete
                                                            id="comboOrgao"
                                                            v-model="cidadeId"
                                                            item-value="Id"
                                                            item-text="Nome"
                                                            :items="cidades"
                                                            label="Cidade"
                                                        ></v-autocomplete>
                                                    </v-flex>
                                                    <v-layout align-center justify-center row wrap>
                                                        <v-flex xs12 sm6 md6 lg6 v-if="!fluxoAlternativo">
                                                            <v-btn                
                                                                style="border-radius: 6px;"
                                                                large
                                                                dark
                                                                @click="controlaExibicaoPlanos()"
                                                                color="#0098DA"
                                                            >Consultar Planos</v-btn>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md6 lg6 v-else>
                                                            <v-btn                
                                                                style="border-radius: 6px;"
                                                                large
                                                                dark
                                                                @click="avancaContratacao()"
                                                                color="#0098DA"
                                                            >Contratar Agora</v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </div>
                    </div>
                    <div class="exibeplanos" v-else>
                        <div class="planos-wrapper">
                            <p class="planos-title">Planos disponíveis
                                <v-btn
                                    icon
                                    dark
                                    @click.prevent="exibeLocalizacao = !exibeLocalizacao"
                                    color="#5f696f"
                                >
                                    <v-icon style="margin-right: 0%;">cached</v-icon>
                                </v-btn>
                            </p>
                            <!-- <p class="planos-title">INDIVIDUAL ANUAL</p> -->
                            <v-container grid-list-md>
                                <v-layout row wrap justify-center>
                                    <v-flex v-for="plano in planos" :key="`3${plano.id}`" xs12 sm12 md12 lg3>
                                        <div class="list-planos">
                                            <div class="item">
                                                <!-- <h6 class="dePara">De</h6>
                                                <p class="priceOld"><span>R$</span> {{plano.oldValue}}<br></p>
                                                <h6 class="dePara">Por</h6> -->
                                                <p class="price"><span>R$</span> {{plano.value}}<br><span>(por pessoa)</span></p>
                                                <h6 class="desconto" v-if="plano.value != plano.familyTable.value2">R$ {{plano.familyTable.value2}} a partir de 2 pessoas</h6>
                                                <h6 class="desconto" v-if="plano.comCarencia" style="color: red; font-weight: bold"><b>*sem carência</b></h6>
                                                <span>
                                                    <p class="cobertura"><span>{{plano.area_atuacao}}</span><b>{{plano.qualificacao}}</b></p>
                                                </span>
                                                <div style="height: 52px;" v-if="plano.typePayment == 'CARTAO'" class="boleto">
                                                    <span>
                                                        <v-img 
                                                            max-height="20px"        
                                                            :src="require('@/Content/images/cartoes.png')"
                                                            max-width="60%"
                                                            style="margin-left: 50px;"
                                                        />
                                                    </span>
                                                    <v-icon style="margin-top: 2px;">credit_card</v-icon>
                                                    {{plano.name}}
                                                </div>
                                                <div v-else style="height: 52px;" class="boleto">
                                                    <span ><p></p></span>
                                                    <i class="fas fa-barcode"></i>
                                                    {{plano.name}}
                                                </div>
                                                <a @click="contratoPF(plano)" class="button">Contratar plano</a>
                                            </div>
                                        </div>
                                    </v-flex>            
                                </v-layout>
                            </v-container>        
                            <p style="text-align: center; font-style: italic">*Exceto prótese - carência de 180 dias</p>
                        </div>
                    </div>
                </v-fade-transition>
            </div>
        </section>
        <v-dialog v-model="dialog" max-width="700px" max-height="400px"> 
            <v-card>
                <v-container grid-list-md>
                    <v-layout row wrap justify-center>
                        <v-card-title>
                            <span class="total">Prezado(a) cliente,</span>              
                        </v-card-title>
                        <v-container fluid pa-1 justify-center class="resumo">
                            <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
                            <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
                            <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
                            <br>
                            <p class="resumo" style="font-weight: bold">A <span style="color:#0098DA">{{informacaoOperadora("nome")}}</span> agradece a sua atenção !</p>
                            <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
                            <br>
                            <p class="resumo" style="font-weight: bold;color:#0098DA">Termo de Privacidade, <a href="" target="_blank">clique aqui.</a></p>
                            <v-checkbox v-model="contrataccept" color="#0098DA">
                                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da {{informacaoOperadora("nome")}}.</span>
                            </v-checkbox>
                        </v-container>
                    </v-layout>
                    <v-card-actions>
                        <v-container fill-height fluid pa-1 justify-center>
                            <br>
                            <v-btn @click="confirmaPlano()" color="#0098DA" depressed style="border-radius: 8px; width: 130px;color: white;">Continuar</v-btn>
                        </v-container>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
        <Snackbar ref=chamaSnackbar />
        <loading :active.sync="isLoading" :can-cancel="true" color="#0098DA" :is-full-page="fullPage"></loading>
    </div>
</template>

<script>
    import Snackbar from '../components/snackbar.vue'
    import axios from 'axios'
    import { baseApiUrl, operadora, } from '@/global'
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        components: { Snackbar, Loading },
        data() {
            return {
                fullPage: true,
                isLoading: false,
                dialog: false,
                abrangenciaAgrupamento: '',
                exibeLocalizacao: true,
                nomeAgrupamento: '',
                planos: [],
                vendedor: [],
                planoSelecionado: [],
                abrangencias: [],
                agrupamentosUF: [],
                abrangenciaUF: '',
                contrataccept: false,
                cidades: [],
                UFs: [],
                fluxoAlternativo: false,
                UfId: '',
                cidadeId: '',
                nomeProjeto: '',
            };
        },

        /* watch: {
            'estado': function () {
                this.cidades = brasil[this.estado].cidades
            }
        }, */
        
        mounted: function() {
            // localStorage.clear()
            // sessionStorage.clear()
            localStorage.removeItem('planoSelecionado')
            sessionStorage.removeItem('cidadeId')
            sessionStorage.removeItem('Vendedor')        
            this.verificaVersao()
            this.pegaParametrosUrl()  
            this.$store.dispatch('ExibeToolbar')
            this.$store.dispatch('ExibeFooter')
            this.exibeLocalizacao = true;
            this.$store.dispatch('Logar')
            this.carregamentoUfs()
            //this.carregaAgrupametos()
        },

        methods: {
            informacaoOperadora(atributo) {
                return operadora[atributo]
            },

            scrollToClass(className) {
                // Get the first element with the given class name
                let el = this.$el.querySelector(className)
                // Get the bounding rectangle so we can get the element position position
                let rect = el.getBoundingClientRect()
                // Scroll to the element (using x and y axis)
                window.scrollTo(rect.left, rect.top)
            },

            scrollbotton() {
                window.scrollTo(0, 3000)
            },

            async controlaExibicaoPlanos() {
                this.abrangenciaId = ''
                this.planos = []
                if (this.cidadeId == '') {
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Selecione o local onde deseja utilizar o plano.","ATENÇÃO")
                } else {
                    this.isLoading = true
                    try {
                        let res = await axios.get(`${baseApiUrl}Abrangencia?filter={"where":{"Municipios":{"inq":[${this.cidadeId}]}}}`) 
                        if (res.data.length !== 0) {
                            this.abrangenciaId = res.data[0].id  
                        }              
                    } catch (error) {
                        this.isLoading = false
                        vm = this;
                        vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao capturar abrangência","ERRO");
                    }
                    try {
                        let url = ''
                        if (this.nomeProjeto) {
                            url = baseApiUrl + 'Plans?filter={"where":{"and":[{"abrangenciaId":{"inq":["'+this.abrangenciaId+'"]}},{"publico":"Pessoa Física"},{"projeto":"'+this.nomeProjeto+'"}]}}'
                        } else {
                            url = baseApiUrl + 'Plans?filter={"where":{"and":[{"abrangenciaId":{"inq":["'+this.abrangenciaId+'"]}},{"publico":"Pessoa Física"},{"projeto":"'+this.informacaoOperadora("nomeMaiusculo")+'"}]}}'
                        }
                        let res = await axios.get(url)
                        if  (res.data.length !== 0 && this.abrangenciaId !== '') {
                            this.planos = res.data
                            this.isLoading = false
                            this.exibeLocalizacao = false;
                        } else {
                            this.isLoading = false
                            vm = this;
                            vm.$refs.chamaSnackbar.snack("#0288D1","Não foram localizados planos para a cidade informada!","INFORMAÇÃO");
                        }
                    } catch (error) {
                        this.isLoading = false
                        vm = this;
                        vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar planos","ERRO");
                    }
                }
            },

            /* contratoPF(plano){
                this.dialog = true
            }, */

            contratoPF(plano) {
                // localStorage.clear()
                // sessionStorage.clear()
                this.planoSelecionado = plano
                this.$store.dispatch('planosPF', this.planoSelecionado)
                localStorage.setItem('planoSelecionado', JSON.stringify(this.planoSelecionado))
                sessionStorage.setItem('cidadeId',this.cidadeId)
                // if (this.vendedor != '')
                    // sessionStorage.setItem('Vendedor', JSON.stringify(this.vendedor))
                this.$router.push({ path: '/contratopf' })
            },

            calculaDesconto(plano) {
                var desconto = parseFloat(plano.oldValue.replace(',', '.')) - parseFloat(plano.value.replace(',', '.'))
                //desconto = desconto.replace('.','.')
                return desconto.toFixed(2).replace('.',',')
            },

            async carregaAgrupametos() {
                this.abrangenciaOrgao = ''
                await axios.get(`${baseApiUrl}AgrupamentoUFs?filter[where][status]=Ativo`).then(res => {        
                    if (res.data != null) {
                        this.agrupamentosUF = res.data.sort(this.compare)
                    }
                })
            },

            compare(a, b) {
                // Use toUpperCase() to ignore character casing
                const agrupamentoA = a.agrupamento;
                const agrupamentoB = b.agrupamento;

                let comparison = 0;
                if (agrupamentoA > agrupamentoB) {
                    comparison = 1;
                } else if (agrupamentoA < agrupamentoB) {
                    comparison = -1;
                }
                return comparison;
            },

            async carregaCidades() {
                this.isLoading = true
                try {
                    let res = await axios.post(`${baseApiUrl}APIS4s/Municipios`,{'idUF':this.UfId}) 
                    if  (res.data != '') {
                        this.cidades = res.data 
                        this.isLoading = false 
                    }
                } catch (error) {
                    this.isLoading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar Cidades","ERRO");
                }
            },

            async carregamentoUfs() {
                try {
                    let res = await axios.get(`${baseApiUrl}APIS4s/UFs`) 
                    if (res.data != '') {
                        this.UFs = res.data
                    }              
                } catch (error) {
                    this.isLoading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar UFs","ERRO");
                }
            },

            async avancaContratacao() {
                var vm = this;
                if (this.cidadeId == '') {
                    vm.$refs.chamaSnackbar.snack("#F9A825","Selecione o local onde deseja utilizar o plano.","ATENÇÃO")
                } else {
                    await axios.get(`${baseApiUrl}Abrangencia?filter={"where":{"Municipios":{"inq":[${this.cidadeId}]}}}`)
                    .then(response => {
                        if (response.data.length !== 0) {
                            this.abrangenciaId = response.data[0].id
                            if (this.abrangenciaId == this.planoSelecionado.abrangenciaId) {
                                this.$store.dispatch('planosPF', this.planoSelecionado)
                                localStorage.setItem('planoSelecionado',JSON.stringify(this.planoSelecionado))   
                                sessionStorage.setItem('cidadeId',this.cidadeId)
                                if (this.vendedor != '')
                                    sessionStorage.setItem('Vendedor',JSON.stringify(this.vendedor))        
                                this.$router.push({ path: '/contratopf' })
                            } else {
                                vm.$refs.chamaSnackbar.snack("#F9A825","Cidade informada está fora da área de abrangência do plano!","ATENÇÃO");
                            }
                        } else {
                            vm.$refs.chamaSnackbar.snack("#F9A825","Cidade informada está fora da área de abrangência do plano!","ATENÇÃO");
                        }
                    })
                    .catch(() => {
                        vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao buscar abrangência","ERRO");
                    })
                }
            },

            async pegaParametrosUrl() {
                var params = window.location.search.substring(1).split('&');
                if (params[0] != '') {
                    //Criar objeto que vai conter os parametros
                    var paramArray = {};

                    //Passar por todos os parametros
                    for (var i=0; i<params.length; i++) {
                        //Dividir os parametros chave e valor
                        var param = params[i].split('=');
                        //Adicionar ao objeto criado antes
                        paramArray[param[0]] = param[1];
                    }
                    if (paramArray['vendedor']) {
                        await axios.get(`${baseApiUrl}Salesmans?filter[where][linkSite]=${paramArray['vendedor']}`).then(res => {        
                            if (res.data != null) {
                                this.vendedor = res.data[0]
                                localStorage.setItem('Vendedor', JSON.stringify(this.vendedor))
                            }
                        })
                    }
                    if (paramArray['plano']) {
                        try {
                            let res = await axios.get(`${baseApiUrl}Plans?filter[where][id]=${paramArray['plano']}`) 
                            if (res.data != '') {
                                this.planoSelecionado = res.data[0]
                                this.fluxoAlternativo = true
                            } else {
                                var vm = this;
                                vm.$refs.chamaSnackbar.snack("#F9A825","Plano não localizado, tente novamente ou entre em contato com a " + this.informacaoOperadora("nome") + ".","ATENÇÃO");
                            }
                        } catch (error) {
                            vm = this;
                            vm.$refs.chamaSnackbar.snack("#F9A825","Plano não localizado, tente novamente ou entre em contato com a " + this.informacaoOperadora("nome") + ".","ATENÇÃO");
                        }
                    }
                    if (paramArray['projeto']) {
                        this.nomeProjeto = paramArray['projeto']
                    }
                }
            },

            async verificaVersao() {
            await axios.get(`${baseApiUrl}Operadoras/versao`).then(res => {
              if (res.data != null) {
              //console.log("Versão no servidor: ", res.data.versao)
              if (!localStorage.getItem('versao')) {
                //console.log("Sem versão ou com versão: ", localStorage.getItem('versao'))
                localStorage.setItem('versao', res.data.versao)
              } else {
                if (localStorage.getItem('versao') != res.data.versao) {
                  //console.log("Com versão, porem antiga. Alterando...")
                  localStorage.setItem('versao', res.data.versao)
                  window.location.reload(true)
                }
              }
              }
            })
          },
        }
    }
</script>

<style>
    .localizacao {
        border: 1px solid;
        border-color: #0098DA;
    }

    .desconto {
        text-align: center;
        margin-bottom: 5px;
        font-size: 15px;
        font-weight: 300;
        color: #666;
        position: relative;
        top: -15px;
        margin-right: -4px;
    }
</style>
